import { TwikeyResponseStatus } from "./registrationV2Slice";
import * as Sentry from "@sentry/react";

/**
 * Copied from Twikey example: https://github.com/twikey/snippets/blob/master/js/webhook.js (404 | PAGE NO LONGER EXISTS...)
 * @param websitekey Provided in Settings > Website
 * @param document Mandatenumber or other
 * @param status Outcome of the request
 * @param token If provided in the initial request
 * @param signature Given in the exit url
 */

// New example (verifyWebHookSignature) ? =>
// https://github.com/twikey/twikey-api-node/blob/61cfe5d8174ca2f5b126b352b0f68f667ec7383f/src/client/TwikeyClient.ts

// The "Website key" can be copied from here:
// Twikey > Settings > Api > Documentation > click button "Copy your website key"
// https://www.beta.twikey.com/r/admin/#/c/settings/api


export const checkExitUrlSignature = async (
    websitekey: string,
    document: string,
    status: TwikeyResponseStatus,
    signature: string,
    token?: string) => {
    try {
        if (!websitekey || !signature) {
            throw "Invalid signature or missing website key";
        }

        let payload = `${document}/${status}`;
        if (token != undefined) {
            payload += "/" + token;
        }

        const hash = await createHmacSha256Hex(websitekey, payload);
        return hash === signature;
    } catch (e) {
        console.error('Error in Twikey checkExitUrlSignature()', e);
        Sentry.setContext('twikeyValues', { websitekey, document, status, token, signature });
        Sentry.captureMessage('Error in Twikey checkExitUrlSignature()');
        return false;
    }
}

// Using "crypto" from Browser (currently failing on Puppeteer in CI)
export const createHmacSha256Hex = async (key: string, payload: string): Promise<string> => {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(key);
    const payloadData = encoder.encode(payload);

    const cryptoKey = await crypto?.subtle?.importKey(
        "raw",
        keyData,
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signatureBuffer = await crypto?.subtle?.sign("HMAC", cryptoKey, payloadData);

    const hash = Array.from(new Uint8Array(signatureBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();

    return hash;
}


/**
 * This method should return the website key configured in Twikey console, it should have a different value based on the environment.
 * @returns Twikey website key
 */
export const getWebsiteKey = () =>
    import.meta.env.VITE_TWIKEY_WEBSITE_KEY !== undefined ? import.meta.env.VITE_TWIKEY_WEBSITE_KEY : 'FE3824EA87B120F7DCC9A7285B45537BFAD4323C7B4A88E15E4C62E5D2FAC401' /* =DEV key */
